import type { AuthRouter } from "replo-publisher/src/trpc/routers/auth";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: authRouter,
  client: authClient,
  utils: authUtils,
  options: authOptions,
} = createTrpcRouterConfig<AuthRouter>({
  path: "auth",
  queryClient: getNamespacedQueryClient("auth"),
});

export { authClient, authRouter, authUtils, authOptions };
